import React from 'react';
import { DecryptionKeyProvider } from '../contexts/DecryptionKeyContext';
import { LanguageProvider } from '../i18n/LanguageProvider';

export const Providers = ({ children }) => {
  return (
    <LanguageProvider>
      <DecryptionKeyProvider>
        {children}
      </DecryptionKeyProvider>
    </LanguageProvider>
  );
};
